import { render, staticRenderFns } from "./StaticDataItem.vue?vue&type=template&id=5f6491e3&scoped=true&"
import script from "./StaticDataItem.vue?vue&type=script&lang=js&"
export * from "./StaticDataItem.vue?vue&type=script&lang=js&"
import style0 from "./StaticDataItem.vue?vue&type=style&index=0&id=5f6491e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6491e3",
  null
  
)

export default component.exports